import Search from "./search";
import {modalNoScrollFix} from "./modal-no-scroll-fix";

class ModalMenu {

    protected container = $('#menuModal');
    protected bNavbar = $('.b-navbar');
    protected navbar = $('.header-new');
    protected burgerIcon = $('.burger-icon');
    protected menuToggle = $('.btn-menu-toggle');
    protected btnMobileSearch = $('.show-mobile-search');
    protected searchContainer = $('.b-header-search');
    protected isOpen = false;
    protected searchInstance;

    constructor() {
        this.container.on({
            'show.bs.modal': () => { this.onShow() },
            'hide.bs.modal': () => { this.ohHide() },
            'hidden.bs.modal': () => { this.onHidden() }
        });

        this.searchInstance = Search.getInstance();

        this.btnMobileSearch.on('click', () => {
            this.searchInstance.show();
        });
    }

    onShow(): void {
        this.navbar.addClass('menu-popover');
        this.bNavbar.addClass('menu-opened');
        this.burgerIcon.addClass('active');

        //modalNoScrollFix.hideScroll()
    }

    ohHide(): void {
        if (this.searchInstance.popup !== null) {
            this.searchInstance.hide();
        }
        //modalNoScrollFix.showScroll()
    }

    onHidden(): void {
        this.navbar.removeClass('menu-popover');
        this.bNavbar.removeClass('menu-opened');
        this.burgerIcon.removeClass('active');
        //modalNoScrollFix.showScroll()
    }
}

export default ModalMenu;
